import React, { useEffect, useRef, useState } from 'react'
import CreatePurchases from '../CreatePurchases/CreatePurchases'
import Button from '../../components/Button'
import api from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import { isAxiosError } from 'axios'
import customMainApi from '../../api/index'
import { useNavigate } from 'react-router-dom'

const AddProduct = () => {
	const navigate = useNavigate()
	const successModalRef = useRef()
	const errorRef = useRef()

	const [itemName, setItemName] = useState('')
	const [color, setColor] = useState('')
	const [memory, setMemory] = useState('')
	const [condition, setCondition] = useState('')
	const [btnLoading, setBtnLoading] = useState(false)
	const [userFields, setUserFields] = useState([])
	const [series, setSeries] = useState([])
	const [serie, setSerie] = useState('')
	const [brand, setBrand] = useState('')
	const [itemGroup, setItemGroup] = useState('')

	const CreateItemsPost = async () => {
		setBtnLoading(true)

		try {
			await api
				.post(`Items`, {
					ItemName: itemName,
					Series: serie,
					ManageBatchNumbers: 'tNO',
					ManageSerialNumbers: 'tYES',
					CostAccountingMethod: 'bis_SNB',
					U_Color: color,
					U_Condition: condition,
					U_Memory: memory,
					U_Group: itemGroup,
					U_Brand: brand,
				})
				.then((res) => {
					successModalRef.current?.open('Продукт успешно создан')
					return JSON.parse(res.data).value
				})
		} catch (e) {
			if (isAxiosError(e)) {
				errorRef.current?.open(
					get(JSON.parse(e.response.data), 'error.message', ''),
				)
			}
		} finally {
			setBtnLoading(false)
		}
	}

	const getItemSeries = () => {
		api
			.post('SeriesService_GetDocumentSeries', {
				DocumentTypeParams: {
					Document: '4',
				},
			})
			.then((res) => {
				const items = JSON.parse(res.data).value
				const filteredItems = items.filter((item) => item.IsManual === 'tNO')
				setSeries(filteredItems)
			})
	}
	const getItems = () => {
		api.get('Items').then((res) => {
			// const items = JSON.parse(res.data).value
			// const filteredItems = items.filter((item) => item.IsManual === 'tNO')
			// setSeries(filteredItems)
		})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM'",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const handlePostBtnClick = () => {
		CreateItemsPost()
	}

	useEffect(() => {
		userFieldsFn()
		getItemSeries()
		getItems()
	}, [])

	return (
		<Layout>
			<CreatePurchases>
				<div className="container minWidthContainer">
					<div className="overflow-y-auto my-8">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 "></thead>
							<tbody>
								<tr className="bg-white  hover:bg-gray-50 ">
									<td className="px-6 py-4 border">
										<div className="searchable-select">
											<div className={'searchableHead'}>
												<div>
													<p>Наименование товара</p>
													<input
														className={
															'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[300px]'
														}
														type="text"
														onChange={(e) => {
															setItemName(e.target.value)
														}}
														placeholder="Наименование товара"
														value={itemName}
													/>
												</div>
											</div>
										</div>
									</td>

									<td className="px-6 border py-4">
										<p>Серия</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(e) => {
												setSerie(e.target.value)
											}}
											value={serie}
										>
											<option key={''} value={''}></option>
											{series.map((item, idx) => (
												<option key={idx} value={item.Series}>
													{item.Prefix}
												</option>
											))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Группа товара</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[150px]'
											}
											onChange={(event) => {
												setItemGroup(event.target.value)
											}}
											value={itemGroup}
										>
											<option value=""></option>
											{userFields
												?.find((item) => item.Name === 'Group')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>
									<td className="px-6 border py-4">
										<p>Бренд</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(event) => {
												setBrand(event.target.value)
											}}
											value={brand}
										>
											<option value=""></option>
											{userFields
												?.find((item) => item.Name === 'Brand')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>
									<td className="px-6 border py-4">
										<p>Состояние</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(event) => {
												setCondition(event.target.value)
											}}
											value={condition}
										>
											<option value=""></option>
											{userFields
												?.find((item) => item.Name === 'Condition')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Цвет</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[150px]'
											}
											onChange={(event) => setColor(event.target.value)}
											value={color}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Color')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Память</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[100px]'
											}
											onChange={(event) => setMemory(event.target.value)}
											value={memory}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Memory')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div
						style={{
							display: 'flex',
							justifyContent: 'end',
							paddingRight: '50px',
							paddingTop: '30px',
						}}
					>
						<Button
							isLoading={btnLoading}
							onClick={handlePostBtnClick}
							disabled={!color || !memory}
						>
							Создать
						</Button>
					</div>
				</div>
			</CreatePurchases>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successModalRef.current = r
					}}
					onConfirm={() => navigate('/purchases')}
				/>
			</>
		</Layout>
	)
}

export default AddProduct
